import React, { useState, useRef } from 'react';
import { Button } from 'primereact/button';
import { InputNumber } from 'primereact/inputnumber';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Document, Page } from "react-pdf";
import { useSelectedContext } from './SelectedContext';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { useParams } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import '../pages/style/DataDocScreen.css';
import api from '../api';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css'; // optional but recommended

const PreviewFileWindow = ({ getDiams, previewTableData, setPreviewData, setPreviewFile, setPdfButVis, showMessage, toastBottomLeft, previewFileData, pdfUrl, diams, previewPageNumber, attributeTableData, setAttributeTableData }) => {
    const [pageNumber, setPageNumber] = useState(previewPageNumber);
    const [numPages, setNumPages] = useState(null);
    const [rotation, setRotation] = useState(0);
    const [zoom, setZoom] = useState(1);
    const [sidebarVisible, setSidebarVisible] = useState(false);
    const { setChildFileLoading } = useSelectedContext();
    const { selectedStationLabel, selectedStationId, selectedDocType, selectedDocId } = useParams();
    const calendarRef = useRef(null);
    const [diamVis, setDiamVis] = useState(false);
    const [fractionValue, setFractionValue] = useState('0');
    const [decimalValue, setDecimalValue] = useState(0);

    const rotateClock = () => {
        const newRotation = (rotation + 90) % 360;
        setRotation(newRotation === 0 ? 0 : newRotation);
        deleteDumbElements();
    };
    
    const rotateCounterClock = () => {
        const newRotation = (rotation - 90) % 360;
        setRotation(newRotation === 0 ? 0 : newRotation);
        deleteDumbElements();
    };

    function previousPage() {
        changePage(-1);
        deleteDumbElements();
    }
    
    function nextPage() {
        changePage(1);
        deleteDumbElements();
    }

    function changePage(offset) {
        if (typeof offset !== 'number' || !Number.isFinite(offset)) {
            return;
        }
        
        setPageNumber((prevPageNumber) => prevPageNumber + offset);
    }

    const handleZoomIn = () => {
        setZoom(zoom + 0.20);
        deleteDumbElements();
    };

    const handleZoomOut = () => {
        setZoom(zoom - 0.20);
        deleteDumbElements();
    };

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
        setPdfButVis(true);
        deleteDumbElements();
    }
    
    const formatDate = (value) => {
        if (!value) return '';
        try {
            const date = new Date(value);
            return isNaN(date) ? '' : date.toLocaleDateString("en-US");
        } catch {
            return '';
        }
    };

    const sanitizeValue = (val) =>
    typeof val === 'string'
        ? val.replace(/[^\x20-\x7E\n\r\t,\.]/g, '').replace(/,/g, ', ')
        : val;
    
    function deleteDumbElements() {
        const interval = setInterval(() => {
            try {
                const textLayers = document.querySelectorAll('.react-pdf__Page__textContent');
                const annotationLayers = document.querySelectorAll('.react-pdf__Page__annotations');
            
                if (textLayers.length === 0 && annotationLayers.length === 0) return;
            
                textLayers.forEach((el) => {
                    if (document.body.contains(el)) {
                    el.style.display = 'none';
                    }
                });
            
                annotationLayers.forEach((el) => {
                    if (document.body.contains(el)) {
                    el.style.display = 'none';
                    }
                });
            
                clearInterval(interval);
            } catch (error) {
                console.error("Error while hiding PDF layers:", error);
                clearInterval(interval);
            }
        }, 300);
        
        return () => clearInterval(interval);
    }

    const handlePrevVerifyClick = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`,
            };
            let requestBody
            if (attributeTableData) {
                requestBody = {
                    files: [previewFileData.file_id],
                };
            }
            else {
                requestBody = {
                    files: [previewFileData.id],
                };
            }

            await api.put('/files/verify_files', requestBody, { headers });
        
            setPreviewFile(prev => ({
                ...prev,
                verified: true,
            }));

            if (attributeTableData) {
                const targetAttribute = attributeTableData.find(attr =>
                    attr.id === previewFileData.id
                );
            
                targetAttribute['verified'] = true;
            }
        
            setChildFileLoading(true);
            showMessage(toastBottomLeft, "success", `${previewFileData.file_name} marked as verified`);
        } catch (error) {
            console.error('Failed to mark files as verified: ', error);
        }
    };
      
    const handlePrevUnVerifyClick = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`,
            };
            let requestBody
            if (attributeTableData) {
                requestBody = {
                    files: [previewFileData.file_id],
                };
            }
            else {
                requestBody = {
                    files: [previewFileData.id],
                };
            }
            await api.put('/files/un_verify_files', requestBody, { headers });
        
            setPreviewFile(prev => ({
                ...prev,
                verified: false,
            }));
            
            if (attributeTableData) {
                const targetAttribute = attributeTableData.find(attr =>
                    attr.id === previewFileData.id
                );
            
                targetAttribute['verified'] = false;
            }
        
            setChildFileLoading(true);
            showMessage(toastBottomLeft, "success", `${previewFileData.file_name} marked as unverified`);
        } catch (error) {
            console.error('Failed to mark files as unverified: ', error);
        }
    };

    const updateItem = async (data) => {
        try {
            const originalItem = previewTableData[pageNumber].find(item => 
                item.attribute === data.attribute && item.record_id === data.record_id
            );

            if (originalItem.value === data.value) {
                return;
            }

            const token = sessionStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`,
            };
            const requestBody = {
                [data.database_column]: data.value
            };
            const file_response = await api.put(`/mtr/update-mtr/${selectedDocId}/${data.record_id}`, requestBody, { headers });
            const updatedFormattedAll = previewTableData[pageNumber].map(item =>
                item.attribute === data.attribute && item.record_id === data.record_id
                  ? { ...item, value: data.value }
                  : item
            );
            setPreviewData(prev => ({
                ...prev,
                [pageNumber]: updatedFormattedAll
            }));
            const file = await api.get(`/files/get-file/${file_response.data.file_id}`, { headers });
            let selectedStationMod;
            if (selectedStationId) {
                selectedStationMod = selectedStationLabel.replace(/%20/g, ' ');
            } else {
                const folderNameObj = previewTableData[pageNumber].find(item => item.attribute === "Folder Name");
                selectedStationMod = folderNameObj?.value || "Unknown Folder";
            }
            const requestBodyAct = {
                'type_id': 6,
                "project_id": parseInt(sessionStorage.getItem('selectedProjectId'),10),
                "description": `manually updated an attribute in file: ${file.data.file_name.split('/').pop()}`,
                "meta_data": {
                    "folder_id": parseInt(selectedStationId,10),
                    "folder_name": selectedStationMod,
                    "doc_type": file.data.document_type_id,
                    "file_id": file.data.id,
                    "old_data": data,
                    "doc_type_name": selectedDocType
                }
            }
            const apiUrlAct = `/activity/add-activity`;
            await api.post(apiUrlAct, requestBodyAct, { headers });
            if (attributeTableData && data?.record_id && data?.attribute) {
                const targetAttribute = attributeTableData.find(attr =>
                    attr.id === data.record_id
                );
            
                if (targetAttribute) {
                    const key = data.attribute.toLowerCase().replace(/ /g, '_');
                    if (key in targetAttribute) {
                        targetAttribute[key] = data.value;
                    }
                }
            }
            showMessage(toastBottomLeft, "success", `Attrbute updated`);
        } catch (error) {
            console.error('Failed to update item: ', error);
        }
    }

    const handleNewDiam = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`,
            };

            // Ensure fractionValue is always a string
            const safeFraction = (fractionValue ?? "").toString().trim();

            const requestBody = {
                decimal_value: decimalValue,
                fraction_value: safeFraction.endsWith('"')
                    ? safeFraction
                    : `${safeFraction}"`,
            };

            await api.post('/mtr/add-diameter', requestBody, { headers });
            showMessage(toastBottomLeft, "success", `New diameter added`);
            setDiamVis(false);
            resetDiamValues();
            getDiams();
        } catch (error) {
            console.error('Failed to add diameter: ', error);
            const detail = error?.response?.data?.detail || "Unable to add diameter";
            showMessage(toastBottomLeft, 'error', detail);
        }
    };

    const resetDiamValues = () => {
        setDecimalValue(0);
        setFractionValue('0');
    };

    const textEditor = (options) => {
        const { value } = options;
        const defaultValue = value !== null && value !== undefined ? value : '';
    
        const handleKeyDown = (e) => {
            e.stopPropagation();
        };
    
        const handleKeyUp = (e) => {
            e.stopPropagation();
        };
    
        const handleClick = (e) => {
            e.stopPropagation();
        };
    
        return (
            <InputText
                type="text"
                value={defaultValue}
                onChange={(e) => options.editorCallback(e.target.value)}
                onKeyDown={handleKeyDown}
                onKeyUp={handleKeyUp}
                onClick={handleClick}
                style={{ width: '100%' }}
            />
        );
    };

    const dropdownEditor = (options) => {
        return (
            <Dropdown
                value={options.value}
                options={diams}
                className="md:w-10rem"
                onChange={(e) => {options.editorCallback(e.value)}}
                placeholder="Select a Diameter"
            />
        );
    };

    const dateEditor = (props) => {
        return (
            <div ref={calendarRef}>
                <Calendar 
                    value={props.rowData.value} 
                    onChange={(e) => {props.editorCallback(e.value)}} 
                    dateFormat="mm/dd/yy"
                    showButtonBar
                />
            </div>
        );
      };

    const allowEdit = (rowData) => {
        return rowData.attribute !== 'Folder Name' && rowData.attribute !== 'Date Created' && rowData.attribute !== 'File Name';
    };

    const onRowEditComplete = (e) => {
        let { newData } = e;
        updateItem(newData);
    };

    const checkCompatibleDiam = (data) => {
        if (!data || !data.attribute || !data.value) return false;

        const attr = data.attribute.toLowerCase();
        const isDiameterAttr = attr === 'diameter' || attr === 'pipe diameter';
        if (!isDiameterAttr) return false;

        const value = data.value.trim();
        return !diams.includes(value);
    };

    const footer = (
        <div>
            <Button label="Cancel" icon="pi pi-times" onClick={() => {setDiamVis(false);resetDiamValues();}} className="p-button-text" />
            <Button label="Submit" icon="pi pi-check" onClick={() => {handleNewDiam()}} autoFocus />
        </div>
    );

    return (
        <div className="pdf-viewer-parent-div">
            <div className="pdf-buttons">
                <Button icon="pi pi-replay" iconPos="right" onClick={rotateCounterClock} />
                <Button icon="pi pi-refresh" iconPos="right" onClick={rotateClock} />
                <Button icon="pi pi-search-plus" iconPos="right" onClick={handleZoomIn} />
                <Button icon="pi pi-search-minus" iconPos="right" onClick={handleZoomOut} />
                <Button disabled={pageNumber <= 1} icon="pi pi-chevron-left" iconPos="right" onClick={previousPage} />
                <p style={{margin: '0px', display: 'flex', alignItems: 'center'}}>Page: </p> 
                <InputNumber
                    className="pdf-page-input"
                    keyfilter="int"
                    value={pageNumber}
                    onChange={(e) => {
                        const newValue = e.value;
                        if (typeof newValue === 'number' && Number.isFinite(newValue)) {
                            setPageNumber(newValue);
                            deleteDumbElements();
                        }
                    }}
                />
                <Button disabled={pageNumber >= numPages} icon="pi pi-chevron-right" iconPos="right" onClick={nextPage} />
                <Button label="Mark as verified" disabled={previewFileData.verified} severity="secondary" onClick={handlePrevVerifyClick} />
                <Button label="Mark as unverified" disabled={!previewFileData.verified} severity="info" onClick={handlePrevUnVerifyClick} />
                <Button
                    icon={sidebarVisible ? 'pi pi-angle-left' : 'pi pi-angle-right'}
                    label={sidebarVisible ? 'Hide Attrbutes' : 'Show Attributes'}
                    onClick={() => setSidebarVisible((prev) => !prev)}
                    outlined
                />
            </div>
            <div className="doc-viewer-content-div">
                <div
                className={`pdf-attribute-table ${sidebarVisible ? 'expanded' : 'collapsed'}`}
                >
                <DataTable
                    scrollable
                    scrollHeight="flex"
                    editMode="row"
                    showGridlines
                    onRowEditComplete={onRowEditComplete}
                    value={previewTableData[pageNumber]}
                >
                    <Column
                        field="attribute"
                        header="Attribute"
                        style={{ whiteSpace: 'pre-wrap', maxWidth: '20rem' }}
                        body={(rowData) => (
                            <div className="prev-attribute-body">
                                <span>{rowData.attribute}</span>
                                {checkCompatibleDiam(rowData) && (
                                    <i
                                        className="pi pi-info-circle"
                                        style={{ color: 'red', cursor: 'pointer' }}
                                        title="This diameter is not one of the supported values required for PODS. Please select a different diameter."
                                    ></i>
                                )}
                            </div>
                        )}  
                    />
                    <Column
                        field="value"
                        header="Value"
                        body={(rowData) => {
                            if (rowData.attribute === 'Date' || rowData.attribute === 'Date Created' || rowData.attribute === 'Date Manufactured' || rowData.attribute === 'Test Date') {
                                return <span>{formatDate(rowData.value)}</span>;
                            }
                                return <span>{sanitizeValue(rowData.value)}</span>;
                        }}
                        editor={(options) => {
                            const attr = options.rowData.attribute;
                            if (attr === 'Diameter' || attr === 'Pipe Diameter') {
                                return dropdownEditor(options);
                            } else if (attr === 'Date' || attr === 'Date Created' || attr === 'Date Manufactured' || attr === 'Test Date') {
                                return dateEditor(options);
                            } else {
                                return textEditor(options);
                            }
                        }}
                        style={{ whiteSpace: 'pre-wrap', maxWidth: '15rem' }}
                    />
                    <Column
                        header="Edit"
                        rowEditor={allowEdit}
                        style={{ textAlign: 'center' }}
                    />
                </DataTable>
                </div>

                <div id="pdf-viewer-content">
                    <Document file={pdfUrl} onLoadSuccess={onDocumentLoadSuccess}>
                        <Page pageNumber={pageNumber} rotate={rotation} scale={zoom} />
                    </Document>
                </div>
            </div>
            <Dialog header='Add New Diamater value to the database:' footer={footer} visible={diamVis} style={{ width: '30vw', height: '40vh' }} onHide={() => {setDiamVis(false);resetDiamValues();}}>
                <div id="new-diam-form">
                    <div className="flex-auto">
                        <label className="font-bold block mb-2">Fraction Value (this value will show up in the dropdown)</label>
                        <InputText value={fractionValue} onChange={(e) => {setFractionValue(e.target.value)}} />
                    </div>
                    <div className="flex-auto">
                        <label htmlFor="minmaxfraction" className="font-bold block mb-2">Decimal Value</label>
                        <InputNumber inputId="minmaxfraction" value={decimalValue} onValueChange={(e) => setDecimalValue(e.value)} minFractionDigits={1} maxFractionDigits={10} />
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default PreviewFileWindow;
